// Memes da comemoração (AC-031), em public/memes — WebP animado, 200 px de altura.
// ATENÇÃO (ASM-013): vieram do GIPHY só para teste; trocar por GIFs licenciados antes da venda.

export const MEMES = [
  '3o6fJ1BM7R2EBRDnxK', // The Office — CONGRATS!
  'g9582DNuQppxC', // brinde do Gatsby
  '3oz8xAFtqoOUUrsh7W', // YOU DID IT
  'l3q2XhfQ8oCkm1Ts4', // aplausos
  'fdyZ3qI0GVZC0', // "I'm really proud of you"
  'Is1O1TWV0LEJi', // The Office — comemoração
  'l0MYt5jPR6QX5pnqM', // The Office — dança
  'kyLYXonQYYfwYDIeZl', // Elmo na festa
  '3o7qDSOvfaCO9b3MlO', // mic drop
  '7rj2ZgttvgomY', // palmas
  't3sZxY5zS5B0z5zMIz', // torcedor empolgado
  '111ebonMs90YLu', // joinha
  'ely3apij36BJhoZ234', // "you otter be proud of yourself"
] as const;

/** Memes tristes do pop-up de fim do tempo grátis (AC-207) — também do GIPHY, só para teste (ASM-103). */
export const SAD_MEMES = [
  '62bRBJV1ccA9nyLmKy', // gatinho chorando com joinha
  'P53TSsopKicrm', // Stitch na chuva
  '3o6wrvdHFbwBrUFenu', // Boo (Monstros S.A.) chorando
  '10tIjpzIu8fe0', // Tristeza (Divertida Mente)
  'OPU6wzx8JrHna', // Patrick segurando o choro
  '0T1tm4a0mrDXXJBO4g', // Bob Esponja na cama
  'lR3pWtb80Hz22UjrYj', // cachorrinho triste
  'd7rvF20PqNuGKSQGhf', // Tyrese chorando
] as const;

export function memeUrl(id: string): string {
  return `/memes/${id}.webp`;
}

let last: string | null = null;

/** Sorteia um meme sem repetir o último mostrado (ASM-013). */
export function pickMeme(random: () => number = Math.random): string {
  const pool = MEMES.filter((m) => m !== last);
  const id = pool[Math.floor(random() * pool.length)] ?? MEMES[0];
  last = id;
  return id;
}
